const VELOCITY = 15;

class Scroller {

    /**
     * 定位到指定的位置（无动画效果）
     * @param element {Element}
     * @param x {int}
     * @param y {int}
     */
    scrollTo(element, x, y) {
        if (element.scrollTo) {
            // console.log("scrollTo_y:"+y)
            element.scrollTo(x, y)
        }

    }

    /**
     * 滑动到指定位置（有动画效果）
     * @param element {Element}
     * @param x {int}
     * @param y {int}
     * @param velocity
     */
    smoothScroll(element, x, y, velocity = VELOCITY) {
        let xV = element.scrollLeft > x ? -velocity : velocity;
        let yV = element.scrollTop > y ? -velocity : velocity;
        let frame = null;
        let step = (timestamp) => {
            let isEnd = 1;
            if (this.scrollToX(element, xV, x)) isEnd = isEnd << 1;
            if (this.scrollToY(element, yV, y)) isEnd = isEnd << 1;
            if (isEnd === 4) {
                window.cancelAnimationFrame(frame);
                return
            }

            frame = window.requestAnimationFrame(step)
        };

        frame = window.requestAnimationFrame(step)
    }

    /**
     * @private
     * @param element {Element}
     * @param velocity
     * @param x
     * @return boolean
     */
    scrollToX(element, velocity, x) {
        let offset = element.scrollLeft;
        if (velocity < 0 && offset + velocity <= x) {
            element.scrollLeft += x - offset;
            return true;
        } else if (velocity > 0 && offset + velocity >= x) {
            element.scrollLeft += x - offset;
            return true;
        } else if (velocity === 0) {
            return true;
        } else {
            element.scrollLeft += velocity;
            return offset === element.scrollLeft;
        }
    }

    /**
     * @private
     * @param element {Element}
     * @param velocity
     * @param y
     * @return boolean
     */
    scrollToY(element, velocity, y) {
        let offset = element.scrollTop;
        if (velocity < 0 && offset + velocity <= y) {
            element.scrollTop += y - offset;
            return true;
        } else if (velocity > 0 && offset + velocity >= y) {
            element.scrollTop += y - offset;
            return true;
        } else if (velocity === 0) {
            return true;
        } else {
            element.scrollTop += velocity;
            return offset === element.scrollTop;
        }
    }
}

const scroller = new Scroller();
export { scroller }
